import { useK3ModelAndAction } from './useK3ModelAndAction';
import { K3Model } from '@k3/core';
import { memo, Suspense } from 'react';

export const K3ModelByKey = memo(
  ({
    modelKey,
    height,
    width,
    depth,
    loadWithoutAction,
  }: {
    modelKey: string;
    height?: number;
    width?: number;
    depth?: number;
    loadWithoutAction?: boolean;
  }) => {
    const { model, modelAction, component } = useK3ModelAndAction(
      modelKey,
      loadWithoutAction
    );

    if (!model || (!loadWithoutAction && !modelAction)) {
      return null;
    }

    return (
      <group>
        <Suspense fallback={null}>
          {component ? (
            <K3Model
              model={model}
              modelAction={modelAction}
              meshProps={{
                ...modelAction?.props,
                width: width ?? modelAction?.props?.width,
                height: height ?? modelAction?.props?.height,
                depth: depth ?? modelAction?.props?.depth,
              }}
              component={component}
              fileURL={model.path}
            />
          ) : (
            <group scale={[width ?? 1, height ?? 1, depth ?? 1]}>
              <K3Model
                model={model}
                modelAction={modelAction}
                meshProps={modelAction?.props}
                component={component}
                fileURL={model.path}
              />
            </group>
          )}
        </Suspense>
      </group>
    );
  }
);

export const K3ModelsByKeys = ({
  modelKeys,
  height,
  width,
  depth,
  loadWithoutAction,
}: {
  modelKeys: string[];
  height?: number;
  width?: number;
  depth?: number;
  loadWithoutAction?: boolean;
}) => {
  return (
    <group>
      {modelKeys.map((modelKey) => (
        <K3ModelByKey
          key={modelKey}
          modelKey={modelKey}
          height={height}
          width={width}
          depth={depth}
          loadWithoutAction={loadWithoutAction}
        />
      ))}
    </group>
  );
};
